var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellsIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 24C2 26.8891 2.56905 29.7499 3.67465 32.419C4.78025 35.0882 6.40076 37.5135 8.44365 39.5563C10.4865 41.5992 12.9118 43.2197 15.581 44.3254C18.2501 45.431 21.1109 46 24 46C26.8891 46 29.7499 45.431 32.419 44.3254C35.0882 43.2197 37.5135 41.5992 39.5563 39.5563C41.5992 37.5135 43.2197 35.0882 44.3254 32.419C45.431 29.7499 46 26.8891 46 24C46 21.1109 45.431 18.2501 44.3254 15.581C43.2197 12.9118 41.5992 10.4865 39.5563 8.44365C37.5135 6.40076 35.0882 4.78025 32.419 3.67465C29.7499 2.56905 26.8891 2 24 2C21.1109 2 18.2501 2.56905 15.581 3.67465C12.9118 4.78025 10.4865 6.40076 8.44365 8.44365C6.40076 10.4865 4.78025 12.9118 3.67465 15.581C2.56905 18.2501 2 21.1109 2 24Z",
    stroke: "#FFDB59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.7778 2C19.3402 4.54625 16.5471 7.86263 14.6225 11.6832C12.698 15.5037 11.6955 19.7221 11.6955 24C11.6955 28.2779 12.698 32.4963 14.6225 36.3168C16.5471 40.1374 19.3402 43.4538 22.7778 46",
    stroke: "#FFDB59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.2222 2C28.6598 4.54625 31.4529 7.86263 33.3775 11.6832C35.302 15.5037 36.3045 19.7221 36.3045 24C36.3045 28.2779 35.302 32.4963 33.3775 36.3168C31.4529 40.1374 28.6598 43.4538 25.2222 46",
    stroke: "#FFDB59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24 2V46",
    stroke: "#FFDB59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellsIcon2);
export default __webpack_public_path__ + "static/media/sells-icon2.549e37cde415469edd55afc633d02f4f.svg";
export { ForwardRef as ReactComponent };